// extracted by mini-css-extract-plugin
export default {"hasCustomColor":"hasCustomColor_fwH94","customSelect":"customSelect_tmTjz","readOnlyCursor":"readOnlyCursor_FdRfw"};